import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

console.log("[main] Bootstrapping React application");

const container = document.getElementById("root");
if (!container) {
  console.error("[main] Failed to find root element");
}
const root = createRoot(container!);

console.log("[main] Rendering App component");
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log("[main] React root render invoked");
